import axios from "axios";
import app from "../_app";

const cart = document.querySelector('.js-cart');

if(cart) {
    const cartProducts = [...document.querySelectorAll('.js-cart-product')];
    const cartEmpty = document.querySelector('.js-cart-empty');
    const cartTotalPrice = document.querySelector('.js-cart-total-price');
    const cartDeliveryCosts = document.querySelector('.js-cart-deliverycosts');
    const cartCheckouts = [...document.querySelectorAll('.js-cart-checkout')];
    const notes = cart.querySelector('.js-cart-notes');
    const updateNotes = cart.querySelector('.js-cart-update-notes');

    const cartProductInit = cartProduct => {
        const id = +cartProduct.dataset.id;

        const quantityInput = cartProduct.querySelector('.js-quantity-input');
        const quantitySelect = cartProduct.querySelector('.js-quantity-select');
        const remove = cartProduct.querySelector('.js-cart-product-remove');
        const price = cartProduct.querySelector('.js-cart-product-price');

        let latestRequestQuantity = quantitySelect ? +quantitySelect.value : +quantityInput.value;

        remove.addEventListener('click', () => {
            quantityInput.value = 0;
            quantityInput.dispatchEvent(new Event('change'));
        });

        const quantityChangeHandler = async ({currentTarget}) => {

            let quantity = +currentTarget.value;
            quantity = Math.max(0, quantity);

            if(quantity !== +currentTarget.value) {
                currentTarget.value = quantity;
            }

            if(quantity !== latestRequestQuantity) {
                try {
                    let {status, data} = await axios.post('/cart/update.js', {updates: {[id]: quantity}});
                    if(status === 200) {
                        if(quantity === 0) {
                            cartProduct.remove();
                        }
                        cartTotalPrice.innerText = '€' + app.currency(data.total_price);

                        if(data.item_count === 0) {
                            cartCheckouts.map(cartCheckout => cartCheckout.setAttribute('disabled', ''));
                            cartEmpty.classList.remove('d-none');
                        }

                        latestRequestQuantity = quantity;
                    }
                } catch(e) {}
            }
        };

        quantityInput.addEventListener('change', quantityChangeHandler);

        if(quantitySelect) {
            quantitySelect.addEventListener('change', quantityChangeHandler);
        }
    };

    const parseAdpPrice = (price) => {
        price = price.toString();

        if(!price.includes('.')) {
            price += '00';
        } else if(price.split('.')[1].length === 1) {
            price += '0';
        }

        return +price.replace('.', '');
    }

    const updateCartPrices = (data) => {
        cartProducts.map((cartProduct) => {
            const {id} = cartProduct.dataset;
            const compareAtPrice = cartProduct.querySelector('.js-cart-product-compare-at-price');
            const price = cartProduct.querySelector('.js-cart-product-price');

            const discount = data.discounts.cart.items.find(row => +row.variant_id === +id);

            if(discount.totalDiscount > 0) {
                if(compareAtPrice.classList.contains('d-none')) {
                    compareAtPrice.classList.remove('d-none');
                }

                price.setAttribute('data-price', parseAdpPrice(discount.discounted_price));
                price.classList.add('c--r');
            } else {
                price.setAttribute('data-price', parseAdpPrice(discount.original_price));

                if(+compareAtPrice.dataset.price === +parseAdpPrice(discount.original_price)) {
                    compareAtPrice.classList.add('d-none');
                    price.classList.remove('c--r');
                }
            }
        });

        cartTotalPrice.innerText = '€' + app.currency(parseAdpPrice(data.discounts.discounted_price));
    }

    const cartCheckoutClickHandler = () => {
        cartCheckouts.map(cartCheckout => {
            cartCheckout.setAttribute('data-state', 'loading');
            setTimeout(() => cartCheckout.setAttribute('disabled', ''));
        });
    }

    cartCheckouts.map(cartCheckout => cartCheckout.addEventListener('click', cartCheckoutClickHandler));
    cartProducts.map(cartProductInit);


    updateNotes.addEventListener('click', () => {
        $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            data: {note: notes.value},
            success: function(result) {
                window.location.href=window.location.href
                return result;
            },
            error: function(jqxhr, status, exception) {
                console.log(exception);
            }
        });
    });
}
